/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useRef, useEffect } from 'react';
import { StyledFilterComponentDiv } from './index.styles';
// import { ComponentProps } from './../../index.types';
import { AllFiltersComponent } from '../allFilters';
import { PriceModalComponent } from '../priceFilters/index.modal';
// import { PointsModalComponent } from '../../molecules/pointsFilter/index.modal';
import { AmenitiesModalComponent } from '../amenitiesFilters/index.modal';
import { BrandsModalComponent } from '../brandFilters/index.modal';
import { QuickFiltersComponent } from '../quickFilters';
import { useConditionalSearchResultAlertContextSERP } from '../../hooks/lib/useConditionalSearchResultAlertContext';
import {
  quickFiltersAndAmenitiesHiddenCodes,
  SearchFacetsConstants,
  SearchFacetsListCodes,
  searchFilters,
} from '../../organisms/SearchResults/index.constant';
import { PointsModalComponent } from '../pointsFilter/index.modal';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent/index';
import clsx from 'clsx';
import { useSearchResultsStore } from '../../modules/store/searchResultsStore';
import { TabComponent } from '@marriott/mi-ui-library';
import { useCheckBreakpoint } from '../../hooks';
import { useConditionalPageContextSERP } from '../../hooks';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const FiltersComponent: React.FC<{
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterUpdateData?: any;
  isStateOrCountrySearch?: boolean;
  isDestinationSearch?: boolean;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tooltipRefElement?: any;
  setTooltipContent?: any;
  modalRefElement?: any;
  setShowToolTip?: React.Dispatch<React.SetStateAction<boolean>>;
  enableMapView?: any;
  enableListView?: any;
}> = ({
  filterUpdateData,
  isStateOrCountrySearch,
  isDestinationSearch,
  className,
  setFetchCurrencyConversionFactors,
  tooltipRefElement,
  setTooltipContent,
  modalRefElement,
  setShowToolTip,
  enableMapView,
  enableListView,
}) => {
  const { pageVal } = useConditionalPageContextSERP();
  const clickTrackingLoc = 'Phoenix Search Results';
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { jsonContent, isFlexibleDateSearch, isStateOrCountry, isMapViewEnabled }: any =
    useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchResultAlerts } = useConditionalSearchResultAlertContextSERP();
  const tooManyProperties = useSearchResultsStore(
    (state: { tooManyProperties: any }) => state.tooManyProperties
  ).tooManyProperties;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const amenities = searchQueryState?.filter?.filter(
    (key: any) => key.type.code === SearchFacetsListCodes.amenities
  )[0];
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number>(0);
  const [scrollLeft, setScrollLeft] = useState<number>(0);
  const containerRef: any = useRef(null);

  const listTabLabel = 'list'; // hardcoded tab value for tab switch
  const mapTabLabel = 'map';
  const [selectedTab, setSelectedTab] = useState(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(searchFilters.view);
    } catch {
      return listTabLabel;
    }
  });

  // Sync selectedTab with isMapViewEnabled when it changes (e.g., browser back navigation)
  useEffect(() => {
    const expectedTab = isMapViewEnabled ? mapTabLabel : listTabLabel;
    if (selectedTab !== expectedTab) {
      setSelectedTab(expectedTab);
    }
  }, [isMapViewEnabled]);

  /**  the below three functions are responsible for horizontal scrolling on mouse drag
   *   handleMouseDown, handleMouseMove, handleMouseUp
   **/
  const handleMouseDown = (e: any) => {
    setIsDragging(true);

    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseMove = (e: any) => {
    if (!isDragging) return;
    const x = e.pageX - containerRef.current.offsetLeft;
    const distance = x - startX;
    containerRef.current.scrollLeft = scrollLeft - distance;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const isLargeDesktop = useCheckBreakpoint('viewportXl');
  const isDesktop = useCheckBreakpoint('viewportL');
  const isTablet = useCheckBreakpoint('viewportM');
  const tabList = [
    {
      tabTitle: jsonContent.addListLabel,
      tabSubtitle: '',
      tabValue: listTabLabel,
      isActive: false,
    },
    {
      tabTitle: jsonContent.mapLabel,
      tabSubtitle: '',
      tabValue: mapTabLabel,
      isActive: false,
    },
  ];

  /**
   * Function to render the content to be display in search filter
   * @param {string}  item  which contains the selected tab data
   */
  const handleTabs = (item: string) => {
    setSelectedTab(item);
    if (item === mapTabLabel) {
      return enableMapView(true);
    } else {
      return enableListView(true);
    }
  };

  return (
    <StyledFilterComponentDiv
      className={clsx(
        pageVal === 'chat'
          ? isLargeDesktop || isDesktop
            ? 'pl-0 d-flex filter-chat-view'
            : 'pl-0 filter-chat-view'
          : 'px-0',
        'container sm-search-result-all-filter-component',
        className
      )}
    >
      <div
        className={clsx(
          'row-1',
          pageVal !== 'chat' ? !isLargeDesktop && !isDesktop && !isTablet && 'ml-3' : 'ml-0',
          'gap-0',
          pageVal !== 'chat' ? (isMapViewEnabled ? 'pt-0 map-1-container' : 'pt-3') : 'pt-0'
        )}
        data-testid={'filtercomp-testid'}
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <div className="row-1-container">
          <div className="all-filters-container">
            <AllFiltersComponent
              hideAvailabiltyFilters={isFlexibleDateSearch || tooManyProperties?.tooManyPorpertiesTriggered}
              hideTaxesToggle={isFlexibleDateSearch}
              hideDistanceFilters={isStateOrCountry}
              hidePriceFilters={isFlexibleDateSearch || tooManyProperties?.tooManyPorpertiesTriggered}
              filterData={filterUpdateData && filterUpdateData?.facets}
              isStateOrCountrySearch={isStateOrCountrySearch}
              isDestinationSearch={isDestinationSearch}
              setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
              tooltipRefElement={tooltipRefElement}
              setTooltipContent={setTooltipContent}
              modalRefElement={modalRefElement}
              setShowToolTip={setShowToolTip}
              isFlexibleDateSearch={isFlexibleDateSearch}
            />
          </div>
          {!isFlexibleDateSearch && !tooManyProperties?.tooManyPorpertiesTriggered && pageVal !== 'chat' ? (
            <div className="price-filter-container">
              {searchQueryState[SearchFacetsConstants.points] ? (
                <PointsModalComponent
                  filterData={filterUpdateData && filterUpdateData?.facets}
                  hideTaxesToggle={isFlexibleDateSearch}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              ) : (
                <PriceModalComponent
                  filterData={filterUpdateData && filterUpdateData?.facets}
                  hideTaxesToggle={isFlexibleDateSearch}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              )}
            </div>
          ) : (
            <div />
          )}
          {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') && pageVal !== 'chat' && (
            <div className="amenities-filter-container">
              <AmenitiesModalComponent
                filterData={filterUpdateData && filterUpdateData?.facets}
                setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                tooltipRefElement={tooltipRefElement}
                setTooltipContent={setTooltipContent}
                modalRefElement={modalRefElement}
                setShowToolTip={setShowToolTip}
              />
            </div>
          )}
          {pageVal !== 'chat' && (
            <div
              className="brand-filters-container custom_click_track"
              {...{ custom_click_track_value: `${clickTrackingLoc}| Filter Selection: Brands |internal` }}
            >
              <BrandsModalComponent
                filterData={filterUpdateData && filterUpdateData?.facets}
                setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
              />
            </div>
          )}
          {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') &&
            amenities?.buckets?.length > 0 && (
              <>
                {pageVal !== 'chat' && <span className="filter-divider"></span>}
                {pageVal !== 'chat' && (
                  <QuickFiltersComponent
                    filterData={filterUpdateData && filterUpdateData?.facets}
                    setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                  />
                )}
              </>
            )}
        </div>
        {(isLargeDesktop || isDesktop) && pageVal !== 'chat' && (
          <TabComponent
            tabList={tabList}
            setSelectedTab={handleTabs}
            selectedTab={selectedTab}
            clickTrackingLoc={clickTrackingLoc} // tab click value
            hidetabsAndContent={false}
            isSwitcherTabs={true} // second varitaion of tab
            disabledContainerClass={true}
            hideTabs={false}
            ariaRole="button"
            tabIcon={{
              map: 'icon-map',
              list: 'icon-list-view',
            }}
            isIconTabs={true}
            isIconWithSwitcher={true}
            iconClass={clsx('m-icon-tab-list-item', 'm-switcher-tab-list-item', 'col-sm-6', 'col-md-auto')}
            classTabsEnabled="filters-tab-no-padding d-flex align-items-center mb-1"
            customTabClickTrackValues={[
              `${clickTrackingLoc} |List View |internal`,
              `${clickTrackingLoc} |Map View |internal`,
            ]}
          />
        )}
      </div>
    </StyledFilterComponentDiv>
  );
};
